<template>
    <div class="c-product-delete">
        <button :title="$t(title)" @click="confirm" class="c-button c-button--neutral c-button--tiny c-button--icon" type="button">
            <svgicon name="close"></svgicon>
            <span v-if="hasSlotData()"><slot></slot></span>
        </button>
    </div>
</template>

<script>
    import Vue from 'vue'

    export default {
        props: {
            title: String,
        },
        components: {},
        data() {
            return {}
        },
        methods: {
            confirm(){
                const confirm = window.confirm('Product verwijderen?')
                if(confirm){
                    this.$emit('change');
                }
            },
            hasSlotData(name) {
                if (name) {
                    return this.$slots[name];
                }
                return this.$slots.default;
            }
        },
    }
</script>

<style lang="scss">

    @import "~@/assets/scss/private";

    .c-product-delete {
        position: absolute;
        top: em($global-spacing-unit-small);
        right: em($global-spacing-unit-small);
    }
</style>


// WEBPACK FOOTER //
// src/components/product/widgets/productDelete.vue